import React from 'react';
import { Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function AboutCreator() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-136">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-137">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-138">
          <div className="relative" data-id="element-139">
            <div className="absolute -inset-4 bg-[#C2410C]/10 rounded-3xl transform -rotate-3" data-id="element-140"></div>
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&q=80" alt="Isabella Romero" className="relative w-full h-auto rounded-2xl shadow-xl object-cover aspect-[4/5]" data-id="element-141" />
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-xl border border-[#3E2723]/10 flex items-center gap-3" data-id="element-142">
              <div className="bg-[#14B8A6]/10 p-2 rounded-full text-[#14B8A6]" data-id="element-143">
                <Award className="w-6 h-6" data-id="element-144" />
              </div>
              <div className="text-sm font-bold text-[#3E2723] whitespace-pre-line" data-id="element-145">
                {t('aboutCreator.badge')}
              </div>
            </div>
          </div>

          <div className="space-y-6" data-id="element-146">
            <h2 className="text-4xl md:text-5xl text-[#3E2723]" data-id="element-147">
              {t('aboutCreator.title')}
            </h2>
            <div className="space-y-4 text-lg text-[#3E2723]/80 leading-relaxed" data-id="element-148">
              <p data-id="element-149">{t('aboutCreator.p1')}</p>
              <p data-id="element-150">{t('aboutCreator.p2')}</p>
              <p data-id="element-151">{t('aboutCreator.p3')}</p>
            </div>
            <div className="pt-4" data-id="element-152">
              <div className="font-[Satisfy,cursive] text-3xl text-[#C2410C] italic" data-id="element-153">
                Isabella Romero
              </div>
              <div className="text-sm text-[#3E2723]/60 uppercase tracking-widest mt-1" data-id="element-154">
                {t('aboutCreator.role')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}